import { useTranslation } from '@dreamstack/i18n'
import {
  LexiconSearchResultBox,
  SearchAutocomplete,
  useLexiconSearchHitsAsArticles,
  useSearchContext,
  useSearchIsSearching,
} from '@dreamstack/search'
import { HeadingH1 } from '../layout/Texts'
import { LoadMoreArticles } from './LoadMoreArticles'

const SearchWrapper = ({ children }: { children: React.ReactNode }) => (
  <div className="flex flex-col space-y-px-32 md:flex-row md:space-y-0 md:mr-px-16">
    {children}
  </div>
)
const ColumnWrapper = ({
  children,
  className,
}: {
  children: React.ReactNode
  className?: string
}) => (
  <div
    className={`flex-1 flex flex-col max-w-full text-left mt-px-32 md:mt-0 ${
      className ?? ''
    }`}
  >
    {children}
  </div>
)

export const LexiconHeaderWithSearch = () => {
  const t = useTranslation()
  const title = t('accentro:propertyLexicon.title')

  // SEARCH
  const isSearching = useSearchIsSearching()
  const hasSearch = useSearchContext()
  const searchArticles = useLexiconSearchHitsAsArticles()

  return (
    <div className="sm:space-y-px-48 sm:mt-px-48 ml:space-y-px-96 ml:mt-px-96 lg:space-y-px-96 lg:mt-px-96">
      <div className="flex flex-col sm:flex-row sm:space-x-px-48 sm:space-y-0">
        <ColumnWrapper>
          <HeadingH1>{title}</HeadingH1>
        </ColumnWrapper>
        {hasSearch && (
          <ColumnWrapper className="sm:justify-end">
            <div className="ml:min-w-[470px]">
              <SearchAutocomplete indexType="lexicon" />
            </div>
          </ColumnWrapper>
        )}
      </div>

      <SearchWrapper>{isSearching && <LexiconSearchResultBox />}</SearchWrapper>
      {isSearching && (
        <LoadMoreArticles articles={isSearching ? searchArticles : []} />
      )}
    </div>
  )
}
